import { render, staticRenderFns } from "./lista-de-solicitudes.vue?vue&type=template&id=67f59b4c&"
import script from "./lista-de-solicitudes.vue?vue&type=script&lang=ts&"
export * from "./lista-de-solicitudes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports